export default __webpack_public_path__ + "static/media/Nine-Grain-Bun.3c429174.jpg";